import Vue from 'vue'
import Router from 'vue-router'
import {
  routerMode
} from '@/config/env'
import store from '@/config/store'
import {
  Translation_FT,
  Translation_JT
} from '../config/lange.js'
Vue.use(Router)

//路由配置
let router = new Router({
  routes: [
    //首页
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/pages/home/index.vue'], resolve),
    },
    //企业文化
    {
      path: '/culture',
      name: 'culture',
      component: resolve => require(['@/pages/home/culture.vue'], resolve),
    },
    //责任列表
    {
      path: '/responsibilityList',
      name: 'responsibilityList',
      component: resolve => require(['@/pages/home/responsibilityList.vue'], resolve),
    },
    //责任详情
    {
      path: '/responsibilityDetails',
      name: 'responsibilityDetails',
      component: resolve => require(['@/pages/home/responsibilityDetails.vue'], resolve),
    },
    //公司动态列表
    {
      path: '/companyList',
      name: 'companyList',
      component: resolve => require(['@/pages/home/companyList.vue'], resolve),
    },
    //公司动态详情
    {
      path: '/companyDetails',
      name: 'companyDetails',
      component: resolve => require(['@/pages/home/companyDetails.vue'], resolve),
    },
    //公司简介
    {
      path: '/Introduction',
      name: 'Introduction',
      component: resolve => require(['@/pages/home/Introduction.vue'], resolve),
    },
    //人才招聘
    {
      path: '/talent',
      name: 'talent',
      component: resolve => require(['@/pages/home/talent.vue'], resolve),
    },
    //同心圆
    {
      path: '/circle',
      name: 'circle',
      component: resolve => require(['@/pages/system/circle.vue'], resolve),
    },
    //易展翅
    {
      path: '/esay',
      name: 'esay',
      component: resolve => require(['@/pages/system/esay.vue'], resolve),
    },
    //我是青年
    {
      path: '/myYouth',
      name: 'myYouth',
      component: resolve => require(['@/pages/system/myYouth.vue'], resolve),
    },
    //齐集
    {
      path: '/qiji',
      name: 'qiji',
      component: resolve => require(['@/pages/system/qiji.vue'], resolve),
    },
    //底部许可证图片
    // {
    //   path: '/certificate',
    //   name: 'certificate',
    //   component: resolve => require(['@/pages/footer/certificate.vue'], resolve),
    // },
    //底部使用条款
    {
      path: '/useTerms',
      name: 'useTerms',
      component: resolve => require(['@/pages/footer/useTerms.vue'], resolve),
    },
    //底部法律声明
    {
      path: '/legalNotices',
      name: 'legalNotices',
      component: resolve => require(['@/pages/footer/legalNotices.vue'], resolve),
    },
    //底部私隐声明
    {
      path: '/privacyStatement',
      name: 'privacyStatement',
      component: resolve => require(['@/pages/footer/privacyStatement.vue'], resolve),
    },
  ],
});
export default router;
//页面加载时
router.beforeEach(function (to, from, next) {
  store.commit('setPageLoading', true);
  store.commit('setPath', to.path)
  if (/\/http/.test(to.path)) {
    let url = to.path.split('http')[1]
    window.location.href = `http${url}`
  } else {
    next();
  }
})


//页面销毁时
router.afterEach(function (to) {
  const language = sessionStorage.getItem('language')
  setTimeout(() => {
    language == 'true' ? Translation_FT() : Translation_JT()
  }, 200)
  window.scrollTo(0, 0)
  store.commit('setPageLoading', false);
});



// WEBPACK FOOTER //
// ./src/router/index.js